import { render, staticRenderFns } from "./ProductFormName.pug?vue&type=template&id=2cf6db0a&lang=pug&"
import script from "./ProductFormName.vue?vue&type=script&lang=js&"
export * from "./ProductFormName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports